<template>
  <div :class="['card-general-info', customClass]">
    <template v-if="hasSections">
      <div v-for="(section, secIndex) in sections" :key="secIndex" class="mb-4">
        <div class="d-flex justify-content-between">
          <p class="card-general-info__title d-flex gap-1 align-items-center">
            <img v-if="section.iconSrc" :src="section.iconSrc" alt="icon" />
            {{ $t(section.title) }}
          </p>
        </div>

        <div class="row mt-2 p-0 general-info-items">
          <div
            v-for="(field, index) in section.items"
            :key="index"
            :class="['general-info', itemClass]"
          >
            <h5 class="title">{{ $t(field?.text) }}</h5>
            <p class="value">{{ field.value }}</p>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="d-flex justify-content-between" v-if="!hideTitle">
        <p class="card-general-info__title d-flex gap-1 align-items-center">
          <img v-if="iconSrc" :src="iconSrc" alt="icon" />
          {{ $t(title) }}
        </p>
      </div>

      <div class="row mt-2 p-0 general-info-items">
        <div v-for="(field, index) in items" :key="index" :class="['general-info', itemClass]">
          <h5 class="title">{{ $t(field?.text) }}</h5>
          <p class="value">{{ field.value }}</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BaseCardInfo',
  props: {
    title: {
      type: String,
      default: 'general-info',
    },
    items: {
      type: Array,
      default: () => [],
    },
    iconSrc: {
      type: String,
      default: null,
    },
    sections: {
      type: Array,
      default: null,
    },
    columns: {
      type: Number,
      default: 4,
    },
    customClass: {
      type: String,
      default: 'col-12',
    },
    itemClass: {
      type: String,
      default: 'col-12 col-sm-6 col-md-4 col-xl-2',
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasSections() {
      return Array.isArray(this.sections) && this.sections.length > 0
    },
  },
}
</script>

<style lang="scss" scoped>
.card-general-info {
  background: var(--color-01);
  border: 1px solid var(--color-64);
  border-radius: 4px;
  padding: 20px 18px;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 18px;

  &__title {
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.25px;
    text-transform: capitalize;
    color: var(--color-03);
    margin-bottom: 0;
  }
}

.general-info-items {
  row-gap: 16px;

  .title {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: var(--color-132);
    margin-block: 4px;
  }

  .value {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: var(--color-115);
    margin-bottom: 0.5rem;
  }
}
</style>
